import { getWebUrl } from '../../../../utilities/browser';
export const postMessageLoggedIn = () => {
    let target;
    let targetOrigin;
    if (PRODUCTION) {
        targetOrigin = `https://${getWebUrl()}`;
        target = window.parent;
        target.postMessage('loggedIn', targetOrigin);
    }
    else {
        targetOrigin = window.location.href;
        target = window;
        target.postMessage('loggedIn', targetOrigin);
    }
};
